/* eslint-disable */
export const VARIABLES: React.ReactElement[] = [
  <i>a</i>,
  <i>b</i>,
  <i>c</i>,
  <i>d</i>,
  <i>x</i>,
  <i>y</i>,
  <i>z</i>,
  <i>ab</i>,
  <i>ac</i>,
  <i>ad</i>,
  <i>bc</i>,
  <i>cd</i>,
  <i>xy</i>,
  <i>yz</i>,
  <i>ax</i>,
  <i>by</i>,
  <i>cz</i>,
]
/* eslint-enable */

export const SIGNS = ['+', '-']

export const RANGE_DATA: RangeDataModel = {
  1: {
    minTerms: 4,
    maxTerms: 10,
    maxVariableIndex: 6,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 10,
  },
  2: {
    minTerms: 4,
    maxTerms: 10,
    maxVariableIndex: 16,
    minCoefficient: 1,
    maxCoefficient: 5,
    minInteger: 1,
    maxInteger: 10,
  },
}

interface RangeDataModel {
  [key: number]: RangeItemModel
}

interface RangeItemModel {
  minTerms: number
  maxTerms: number
  maxVariableIndex: number
  minCoefficient: number
  maxCoefficient: number
  minInteger: number
  maxInteger: number
}
